import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getSignUpState(state) {
  return getStateWithOnlyOneLevel(state, 'signup');
}

export const getRates = (state) => getSignUpState(state).get('rates');

export const getPlans = (state) => getSignUpState(state).get('plans');

export const getCoupon = (state) => getSignUpState(state).get('coupon');

export const getReferences = (state) => getSignUpState(state).get('references');

export const getRatingExamQuestions = (state) =>
  getSignUpState(state).get('ratingExamQuestions');

export const getReferencesPmk = (state) =>
  getSignUpState(state).get('referencesPmk');

export const getLoadingReferences = (state) =>
  getSignUpState(state).get('loadingReferences');

export const getCycle = (state) => getSignUpState(state).get('cycle');

export const getCheckEmailExistsMessage = (state) =>
  getSignUpState(state).get('checkEmailExistsMessage');

export const getCheckEmailExistsWaiting = (state) =>
  getSignUpState(state).get('checkEmailExistsWaiting');

export const getCheckEmailExistsSuccess = (state) =>
  getSignUpState(state).get('checkEmailExistsSuccess');

export const getSubscriptionWaiting = (state) =>
  getSignUpState(state).get('subscriptionWaiting');

export const getSubscriptionSuccess = (state) =>
  getSignUpState(state).get('subscriptionSuccess');

export const getSubscriptionMessage = (state) =>
  getSignUpState(state).get('subscriptionMessage');

export const getWarfareAndQualificationReference = (state) =>
  getSignUpState(state).get('quals');

// COUNTERS
export const getChaptersWithoutQuestions = (state) =>
  getSignUpState(state).get('chaptersWithoutQuestions');

export const getChaptersCount = (state) =>
  getSignUpState(state).get('chaptersCount');

export const getQuestionsOccupationalCounter = (state) =>
  getSignUpState(state).get('questionsOccupationalCounter');

export const getQuestionsPmkCounter = (state) =>
  getSignUpState(state).get('questionsPmkCounter');

export const getChaptersPmkCount = (state) =>
  getSignUpState(state).get('chaptersPmkCount');

export const getChaptersPmkWithoutQuestions = (state) =>
  getSignUpState(state).get('chaptersPmkWithoutQuestions');
